import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { httpOptionsV1, httpOptionsV3 } from '../../../service/headers.version';
import { LookupTable } from '../model/domain/lookupTable';
import { UserProfile } from '../model/domain/userProfile';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  createEmpty(): BehaviorSubject<LookupTable[]> {
    return new BehaviorSubject<LookupTable[]>([]);
  }

  private _userRules: BehaviorSubject<LookupTable[]>;
  public currentRules: Observable<LookupTable[]>;

  constructor(private http: HttpClient) {
    this._userRules = this.createEmpty();
    this.currentRules = this._userRules.asObservable();
  }

  public async loadRules() {
    return new Promise<any>((resolve, reject) => {
      this.getRules().subscribe({
        next: data => {
          this._userRules.next(data)
          return resolve(this._userRules);
        },
        error: (e) => {
          console.log(e);
          return resolve(undefined);
        }
      })
    })
  }
  private getRules(): Observable<LookupTable[]> {
    return this.http
      .post<any>(environment.api_url + '/portal/LookupTable', { wrapper: { lookupTableRequest: { name: 'function_rules' } } }, httpOptionsV3)
      .pipe(map((response: any) => response.content.lookupTableResponse.function_rules));
  }

  public getUserProfile(): Observable<UserProfile> {

    return this.http
      .post<any>(environment.api_url + '/portal/userprofile', { wrapper: { userProfileRequest: { name: 'user_profile', platform: 'autos' } } }, httpOptionsV1)
      .pipe(map((response: any) => response.content.userProfileResponse.user_profile));
  }
  public getUserProfiles(): Observable<UserProfile[]> {
    return this.http
      .post<any>(environment.api_url + '/portal/userprofile', { wrapper: { userProfileRequest: { name: 'user_profile', platform: 'autos' } } }, httpOptionsV1)
      .pipe(map((response: any) => response.content.userProfileResponse.user_profile));
  }

  public checkIfUserExist(username: string): Observable<any> {
    let response = this.http
      .post<any>(environment.api_url + '/portal/UserExist', { wrapper: { userName: username } }, httpOptionsV1);
    return response;
  }
}

